module.exports = __webpack_public_path__ + "static/tickethoss_logo_small-a77220f6c4290edea719ce579dfb82b9.svg";